import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { Config } from '../../components';
import { Language } from '../../contracts';
import { ErrorHandler } from '../../util';
import { getAllLanguagesQuery, getLanguagesByCountryQuery } from './Queries/';

export class LanguageApolloClient {

  private apolloClient: ApolloClient<NormalizedCacheObject>;

  constructor(identityToken: string, config: Config) {
    const httpLink = createHttpLink({
      uri: config.webAPIConfig.graphQlHttpApiUrl,
    });

    const authLink = setContext((_, { headers }) => ({
      headers: {
        ...headers,
        authorization: identityToken ? `Bearer ${identityToken}` : '',
      },
    }));

    this.apolloClient = new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache(),
    });
  }

  public async getAllLanguages(): Promise<Array<Language>> {
    try {
      const queryResult = await this.apolloClient.query({
        query: getAllLanguagesQuery,
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
      });

      return queryResult.data.languages;
    } catch (error) {
      ErrorHandler.handleError(error);
      return [];
    }
  }

  public async getLanguagesByCountry(countryId: string): Promise<Array<Language>> {
    try {
      const queryResult = await this.apolloClient.query({
        query: getLanguagesByCountryQuery,
        variables: { countryId },
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
      });

      return queryResult.data.languagesByCountry;
    } catch (error) {
      ErrorHandler.handleError(error);
      return [];
    }
  }
}
